// extracted by mini-css-extract-plugin
module.exports = {"DataLoader":"DataLoader_DataLoader__23V23"};